import { Reveal, Eyebrow } from "@/components/site/Reveal";

const HERBS = [
  ["Boron", "Mineral", "Supports detoxification, a healthy inflammation response and brain function."],
  ["Tongkat Ali", "Root", "Used for centuries in the East for male vitality; an antioxidant for prostate circulation."],
  ["Ashwagandha", "Herb", "An ancient herb linked to prostate health, desire and lean muscle."],
  ["Fenugreek", "Seed", "Contains furostanol saponins, associated with prostate function and libido."],
  ["Panax Ginseng", "Root", "A traditional root for desire, healthy blood flow and immune function."],
  ["Maca Root", "Root", "A Peruvian plant associated with prostate function, sex drive and energy."],
  ["Artichoke", "Extract", "Rich in natural antioxidants to help maintain prostate health."],
  ["Nettle Root", "Root", "Long used for urinary tract health and healthy hormone levels in men."],
];
const MINERALS = [["Zinc", "Sperm production, libido and sleep."], ["Magnesium", "Deeper sleep, healthy vessels, energy."], ["Vitamin D", "Mood, metabolism, bones and prostate."]];

const Herb = ([name, tag, body], i) => (
  <Reveal key={name} delay={(i % 4) * 0.06} className="h-full">
    <div className="group flex h-full flex-col justify-between rounded-[1.5rem] border border-[#F2EDE4]/10 bg-[#0B2A45] p-6 transition-[transform,background-color] duration-500 hover:-translate-y-1 hover:bg-[#0E3456]" data-testid={`prosta-ingredient-${i}`}>
      <div className="flex items-center justify-between">
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#00AEEF]">{tag}</span>
        <span className="font-mono text-xs text-[#F2EDE4]/55">0{i + 1}</span>
      </div>
      <div className="mt-10">
        <h3 className="font-display text-2xl font-bold tracking-tight text-[#F2EDE4]">{name}</h3>
        <p className="mt-2 text-sm leading-relaxed text-[#F2EDE4]/75">{body}</p>
      </div>
    </div>
  </Reveal>
);

export const ProstaIngredients = () => (
  <section id="ingredients" className="bg-[#071E33] py-24 sm:py-32" data-testid="prosta-ingredients-section">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="flex flex-col justify-between gap-6 md:flex-row md:items-end">
        <div>
          <Eyebrow className="!text-[#00AEEF]">Inside every scoop</Eyebrow>
          <h2 className="mt-5 max-w-2xl font-display text-4xl font-bold leading-[1.02] tracking-tight text-[#F2EDE4] sm:text-5xl">
            Eight botanicals, <span className="font-serif italic font-normal text-[#00AEEF]">three minerals.</span>
          </h2>
        </div>
        <p className="max-w-sm text-base text-[#F2EDE4]/70">Descriptions summarised from the maker's page. Check the official label for exact amounts.</p>
      </Reveal>
      <div className="mt-14 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">{HERBS.map(Herb)}</div>
      <Reveal className="mt-4">
        <div className="grid grid-cols-1 items-center gap-6 rounded-[1.5rem] bg-[#F2EDE4] p-6 sm:p-8 lg:grid-cols-12" data-testid="prosta-minerals">
          <p className="font-display text-2xl font-bold text-[#071E33] lg:col-span-3">Plus a mineral blend</p>
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 lg:col-span-9">
            {MINERALS.map(([n, d]) => (
              <div key={n} className="border-l-2 border-[#00AEEF] pl-4">
                <p className="font-display text-lg font-semibold text-[#071E33]">{n}</p>
                <p className="text-sm text-[#071E33]/75">{d}</p>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
